/**
 * TutorialManager.js
 * Provides an interface to access the general game settings.
 */

import { Game, DesignDataTypes, CoreEvents, InputMethod } from "pixi_core";

export class TutorialManager {
    constructor() {
        /** @private @type {Object[]} */
        this._tutorials = [];

        Game.on(CoreEvents.eDESIGNDATAMANAGER_READY, this._onDesignDataReady, this);
    }

    /**
     * @private
     */
    _onDesignDataReady() {
        const tutorials = Game.design.getData("Tutorials", DesignDataTypes.eGLOBAL_ENTITY);

        const settings = tutorials.children;

        let settingsCopy = JSON.parse(JSON.stringify(settings));

        for (let i = 0; i < settingsCopy.length; ++i) {
            delete settingsCopy[i].id;
            delete settingsCopy[i].type;
            delete settingsCopy[i].x;
            delete settingsCopy[i].y;

            for (let j = 0; j < settings[i].children.length; ++j) {
                delete settingsCopy[i].children[j].name;
                delete settingsCopy[i].children[j].id;
                delete settingsCopy[i].children[j].type;
                delete settingsCopy[i].children[j].x;
                delete settingsCopy[i].children[j].y;
            }
        }

        let settingsCopyCopy = [];

        for (let i = 0; i < settings.length; ++i) {
            settingsCopyCopy[settingsCopy[i].name] = settingsCopy[i];
        }

        this._tutorials = settingsCopyCopy;
    }

    /**
     * @public
     * @param {String} tutorialId
     * @returns {Object}
     */
    getTutorialStepData(tutorialId) {
        let tutotialStepData = this._tutorials[tutorialId].children;

        return tutotialStepData;
    }

    /**
     * @public
     * @param {String} tutorialId
     * @returns {String}
     */
    getTutorialSaveGameEvent(tutorialId) {
        let saveGameEventId = this._tutorials[tutorialId].SaveGameEventId;

        return saveGameEventId;
    }

    /**
     * @public
     * @returns {Boolean}
     */
    get usingKeyboardControls() {
        return Game.input.lastInputMethod === InputMethod.eKEYBOARD;
    }

    /**
     * @public
     * @returns {Boolean}
     */
    get usingPointerControls() {
        return Game.input.lastInputMethod === InputMethod.eMOUSE || Game.input.lastInputMethod === InputMethod.eTOUCH;
    }
}
